module.exports = __webpack_public_path__ + "static/media/2-min.854f92bc.jpg";